module.exports = __webpack_public_path__ + "media/images/sprites/red-a7e4a50b530a77b6ff8e4135b7ecf2e1.png";